const namespace = 'staff_shift/'

export const CLEAR_STAFF_LIST = namespace + '.CLEAR_STAFF_LIST'
export const SET_STAFFS_LIST = namespace + '.SET_STAFFS_LIST'
export const CLEAR_USERS_LIST = namespace + '.CLEAR_USERS_LIST'
export const SET_USERS_LIST = namespace + '.SET_USERS_LIST'
export const SET_SELECTED_STAFFS_LIST = namespace + '.SET_SELECTED_STAFFS_LIST'
export const SET_SELECTED_OFFICE_ID = namespace + '.SET_SELECTED_OFFICE_ID'
